import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RocketLaunch } from '@mui/icons-material';
import { Typography, Box, Divider } from '@mui/material';
import { zont_colors } from 'console/theme/styles/colors/brands';
import { UserCustomColors } from 'console/theme/styles/types';
import { MaterialColorPicker } from 'shared/components/fields';
import { useDesignPackage } from 'shared/hooks/helpers';
import { memo, useCallback } from 'react';
const user_custom_colors = [
    { label: 'Основной цвет', color: UserCustomColors.primary },
    { label: 'Вторичный цвет', color: UserCustomColors.secondary },
    { label: 'Цвет ошибки', color: UserCustomColors.error },
    { label: 'Цвет предупреждения', color: UserCustomColors.warning },
    { label: 'Цвет успеха', color: UserCustomColors.success },
    { label: 'Цвет информации', color: UserCustomColors.info },
    { label: 'Цвет заднего фона', color: UserCustomColors.background },
];
export const UserThemingController = memo(function UserThemingController(props) {
    const { value, onChange } = props;
    const allow_design_package = useDesignPackage();
    const onChangeColor = (field, theme_color) => (color) => {
        onChange({
            ...value,
            [theme_color]: {
                ...value?.[theme_color],
                [field]: color,
            },
        });
    };
    const user_colors = useCallback((theme_color) => user_custom_colors.map(({ label, color }) => (_jsx(MaterialColorPicker, { onChange: onChangeColor(color, theme_color), value: value?.[theme_color]?.[color], label: label, default_palette: zont_colors(theme_color === 'dark')[color], allow_design_package: allow_design_package }, label))), [value]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [_jsxs(Box, { display: "flex", alignItems: "center", columnGap: 2, children: [_jsx(Typography, { variant: "h6", children: "\u0426\u0432\u0435\u0442\u0430" }), !allow_design_package && _jsx(RocketLaunch, { color: "primary" })] }), _jsxs(Box, { display: "flex", flexWrap: "wrap", gap: 3, children: [_jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsx(Typography, { fontSize: "1.5rem", children: "\u0421\u0432\u0435\u0442\u043B\u0430\u044F \u0442\u0435\u043C\u0430" }), user_colors('light')] }), _jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsx(Typography, { fontSize: "1.5rem", children: "\u0422\u0435\u043C\u043D\u0430\u044F \u0442\u0435\u043C\u0430" }), user_colors('dark')] })] }), _jsx(Divider, {})] }));
});
